import { createModuleStore } from '../utils'

export const useInventoryItemTypesStore = createModuleStore(
  'inventoryItemTypes',
  {
    type: 'InventoryItemType',
    pageHeading: 'Inventory Item Types',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/inventoryItemTypes',
    serviceUri: '/inventoryItemTypes',
    listingModuleName: 'Config',
    listingActivityName: 'View Item Type',
    formModuleName: 'Config',
    formActivityName: 'Edit Item Type',
    allFields: [
      {
        key: 'itemNumber',
        title: 'ITEM NUMBER',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'description',
        title: 'DESCRIPTION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'alternativePart1',
        title: 'ALTERNATIVE PART 1',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'alternativePart2',
        title: 'ALTERNATIVE PART 2',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'itemClass',
        title: 'ITEM CLASS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'cycleFrequency',
        title: 'CYCLE FREQUENCY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'rmIndicator',
        title: 'RM INDICATOR',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'location',
        title: 'LOCATION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'stockroom',
        title: 'STOCKROOM',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'manufacturer',
        title: 'MANUFACTURER',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'manufacturerPartNumber',
        title: 'MANUFACTURER PART NUMBER',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'vendor',
        title: 'VENDOR',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'vendorPartNumber',
        title: 'VENDOR PART NUMBER',
        visible: false,
        sortable: true,
        disabled: false,
      },

      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    parentName: null,
    multipleTagsAllowedLabel: null,
    hiddenLabel: null,
  },
  {
    copy(item) {
      const obj = {
        description: item.description,
        multipleTagsAllowed: item.multipleTagsAllowed,
        hidden: item.hidden,
        samplingPeriodSeconds: item.samplingPeriodSeconds,
        samplingThreshold: item.samplingThreshold,
        parent: item.parent,
      }
      return obj
    },
    resetPageFilters() {
      const store = useInventoryItemTypesStore()
      store.resetBaseFilters()
    },
  },
  {
    actionBindings: {
      multipleTagsAllowed: 'multipleTagsAllowedUpdated',
      hidden: 'hiddenUpdated',
    },
    fields: [
      {
        id: 'iit_item_number',
        name: 'itemNumber',
        label: 'Item Number',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item type number' },
        rules: [
          {
            required: true,
            max: 50,
            trigger: ['blur', 'input'],
          },
          /*
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
          */
        ],
      },
      {
        id: 'iit_description',
        name: 'description',
        label: 'Description',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item type description' },
        rules: [
          {
            required: true,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_alternative_part_1',
        name: 'alternativePart1',
        label: 'Alternative Part 1',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter alternative part' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_alternative_part_2',
        name: 'alternativePart2',
        label: 'Alternative Part 2',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter alternative part' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_item_class',
        name: 'itemClass',
        label: 'Item Class',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item class' },
        rules: [
          {
            required: true,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_cycle_frequency',
        name: 'cycleFrequency',
        label: 'Cycle Frequency',
        size: 6,
        component: 'NSelect',
        componentProps: { placeholder: 'Enter cycle frequency' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_rm_indicator',
        name: 'rmIndicator',
        label: 'RM Indicator',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter indicator' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_location',
        name: 'location',
        label: 'Location',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter location' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_stockroom',
        name: 'stockroom',
        label: 'Stockroom',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter stockroom' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_manufacturer',
        name: 'manufacturer',
        label: 'Manufacturer',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter manufacturer' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_manufacturer_part_number',
        name: 'manufacturerPartNumber',
        label: 'Manufacturer Part Number',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter part number' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_vendor',
        name: 'vendor',
        label: 'Vendor',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter vendor' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'iit_vendor_part_number',
        name: 'vendorPartNumber',
        label: 'Vendor Part Number',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter part number' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
